import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAlertType, IRiderAlert } from 'app/core/models/rider-alert.model';
import { SweetAlertOptions } from 'sweetalert2';
import { isNullOrUndefined } from 'util';
import { RiderAlertService } from '../../services/rider-alert.service';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-create-rider-alerts',
  templateUrl: './create-rider-alerts.component.html',
  styleUrls: ['./create-rider-alerts.component.scss']
})
export class CreateRiderAlertsComponent implements OnInit, OnDestroy {

  @Input() alert: IRiderAlert;
  @Input() riderId: number;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() update: EventEmitter<boolean> = new EventEmitter<boolean>();

  public alertTypes: any[];
  public editing: boolean;
  public form: FormGroup;
  private subscrip: Subscription[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private riderAlertService: RiderAlertService,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
  }

  ngOnInit() {
    this.getAlertTypes();
    this.getIfEditing();
  }

  private getAlertTypes() {
    this.subscrip.push(this.riderAlertService.getAlertTypes()
      .subscribe(
        (alertTypes: IAlertType[]) => {
          this.alertTypes = alertTypes;
        }
      ));
  }

  private getIfEditing() {
    this.editing = !isNullOrUndefined(this.alert);
    if (this.editing) {
      this.form = this.formBuilder.group(
        {
          rideralertid: [this.alert.rideralertid, Validators.required],
          description: [this.alert.description, Validators.required],
          alerttypeid: [this.alert.alerttypeid, Validators.required],
          riderid: [this.alert.riderid, Validators.required],
          userprofileid: [this.alert.userprofileid, Validators.required],
          isactive: [this.alert.isactive]
        }
      );
    } else {
      this.createForm();
    }
  }

  private createForm() {
    this.form = this.formBuilder.group(
      {
        alerttypeid: [null, Validators.required],
        description: [null, Validators.required],
        riderid: [null, Validators.required]
      }
    );
    this.setRiderId();
  }

  private setRiderId() {
    this.form.get('riderid').setValue(this.riderId);
  }

  onClose() {
    this.form.reset();
    this.close.emit(true);
  }

  onSave() {
    const serviceFunction = this.editing ? 'updateAlert' : 'saveAlert';
    this.subscrip.push(this.riderAlertService[serviceFunction](this.form.value).subscribe(
      this.onResponse,
      this.onError
    ));
  }

  onResponse = ({ success, message }) => {
    if (success) {
        this.onClose();
    }
    this.sweetAlertHelper.createCustomAlert(
      {
        title: message,
        type: success ? 'success' : 'error'
      } as SweetAlertOptions
    );
    this.update.emit(true);
  }
  /**
   * @description al presentarse un error
   */
  onError = ({message, modelstate}) => {
    const text: string[] = [];
    if (modelstate) {
      Object.keys(modelstate).forEach(
        key => {text.push(modelstate[key]); }
      );
    }
    this.sweetAlertHelper.createCustomAlert(
      {
        title: message,
        html: `<div>${text}</div>`,
        type: 'error'
      } as SweetAlertOptions
    );
  }
  ngOnDestroy(): void {
    this.subscrip.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/create-rider-alerts/create-rider-alerts.component.ts